"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deepmerge_1 = __importDefault(require("deepmerge"));
const defaults_1 = require("../constants/defaults");
const rmInactiveWebVitalsEventDetails_1 = __importDefault(require("../events/rmInactiveWebVitalsEventDetails"));
/**
 * Initialize the Client Profiler configuration. Merge all configuration
 * sources, later sources taking precedence:
 *
 * 1. _Default config_ from DEFAULT_CONFIG in ../constants/defaults.ts
 * 2. _Instance config_ from `new ClientProfiler(config)`
 * 3. _Global config_ from `window.CLIENT_PROFILER_CONFIG`
 *
 * @param instanceConfig ClientProfiler configuration from instantiation
 * @returns The merged configuration object or undefined if we're not in a
 *   browser environment.
 */
function initConfig(instanceConfig) {
    // Check for a global config object if we're in a browser environment. See
    // PERF-802.
    const windowConfig = typeof window !== 'undefined' &&
        window.CLIENT_PROFILER_CONFIG;
    const config = deepmerge_1.default.all([
        defaults_1.DEFAULT_CONFIG,
        instanceConfig || {},
        windowConfig || {},
    ]);
    // Drop event details for Web Vitals metrics that are not supported
    // by the browser
    (0, rmInactiveWebVitalsEventDetails_1.default)(config);
    return config;
}
exports.default = initConfig;
